import angular from 'angular';

import { styleRule } from './StyleRule';
import './styles.css';

/**
* @ngdoc    overview
* @name     csm.styles
* @description
* Styling utilities
**/

export default angular
  .module('csm.styles', [])
  .constant("StyleRule", styleRule)
  .name;
